import React from 'react';
import {Button, Input} from 'semantic-ui-react';

const Search = ({search, handleSearchChasis, handleInput, text, type}) => {
  return (
    <div className="tcc-header-search-row">
      <Input
        type={type ? 'number' : 'text'}
        className="input-search-tcc mr"
        color="grey"
        icon="search"
        name="search"
        value={search ? search : ''}
        onChange={(e, data) => {
          handleInput(e, data);
        }}
        placeholder={text ? text : 'Ingresar chasis...'}
      />
      <Button disabled={search.length < 5} onClick={handleSearchChasis} color="blue">
        BUSCAR
      </Button>
    </div>
  );
};

export default Search;
